import { Link2 } from "lucide-react";
import { presenceColor, type LinkPresence } from "@/lib/foreign-agents";
import { cn } from "@/lib/utils";

const PRESENCE_TEXT: Record<LinkPresence, string> = {
  online: "its machine is online",
  offline: "its machine is offline",
  unpaired: "not paired with a machine yet",
};

/**
 * The corner mark on a foreign agent's avatar: a link glyph, tinted by whether its
 * machine is connected. Sits top-right, clear of the status dot bottom-right, and
 * is drawn by both avatars (`AgentAvatar` from the agents list, `Avatar` from a
 * users row) so a foreign agent reads the same on a card, a comment and the list.
 */
export function ForeignMark({ presence, size = "md" }: { presence: LinkPresence; size?: "xs" | "sm" | "md" }) {
  return (
    <span
      role="img"
      aria-label={`Foreign agent: ${PRESENCE_TEXT[presence]}`}
      title={`Runs on its own machine — ${PRESENCE_TEXT[presence]}`}
      className={cn(
        "absolute -right-1 -top-1 grid place-items-center rounded-full border border-background bg-background",
        size === "xs" ? "size-2.5" : size === "sm" ? "size-3.5" : "size-4",
      )}
      style={{ color: presenceColor(presence) }}
    >
      <Link2 aria-hidden strokeWidth={2.75} className={size === "xs" ? "size-2" : size === "sm" ? "size-2.5" : "size-3"} />
    </span>
  );
}
